import { CountryEntity } from 'api/types/entity';
import { useTranslation } from 'libs/i18n';
import { Stack, Typography } from 'libs/ui';
import { AddressFields, Section } from 'modules/client/common/components';
import { DocumentsTableFeature } from 'modules/client/common/feature';
import {
  Field,
  useFormContext,
} from 'modules/client/common/forms/residentialAddressForm';

interface Props {
  countriesLoading?: boolean;
  countries: CountryEntity[];
}

export const RegistrationAndResidentialAddressSection = ({
  countriesLoading,
  countries,
}: Props) => {
  const { t } = useTranslation();

  const { values } = useFormContext();

  return (
    <Section
      datax="registrationAndResidentialAddressSection"
      title={t('client.client.registrationAndResidentialAddress.title')}
    >
      <Stack spacing={12}>
        <Stack spacing={12}>
          <Typography variant="bodyBold">
            {t('client.client.registrationAddress.title')}
          </Typography>
          <AddressFields
            countries={countries}
            countriesLoading={countriesLoading}
            variant="registrationAddress"
          />
        </Stack>
        <Stack spacing={12}>
          <Stack direction="row" spacing={12}>
            <Typography variant="bodyBold">
              {t('client.client.residentialAddress.title')}
            </Typography>
            <Stack
              alignItems="center"
              direction="row"
              flexWrap="wrap"
              justifyContent="space-between"
              spacing={16}
            >
              <Typography variant="bodyMedium">
                {t(
                  'client.client.registrationAndResidentialAddress.residencelabel'
                )}
              </Typography>
              <Field.Switch name="residentialAddress.residentialAddressIsSame" />
            </Stack>
          </Stack>
          {!values.residentialAddress.residentialAddressIsSame && (
            <AddressFields
              countries={countries}
              countriesLoading={countriesLoading}
              variant="residentialAddress"
            />
          )}
          <DocumentsTableFeature name="residentialAddress.proofOfResidenceFiles" />
        </Stack>
      </Stack>
    </Section>
  );
};
